import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';

import { FILTER_KEYS, TEAM, ZONE_TYPE } from '../../../../config/constants';
import { scopeIsModalPlayer } from '../../../../helpers';
import { useFiltersDispatch, useFiltersState } from '../../../../store/hooks';
import { BasicFilterPropsType } from '../type';
import { useRouter } from '../../../../helpers/customHooks';
import { ZoneTypeFilterData } from './types';

export const ZoneTypeFilter = ({ forceScope, show, customView, close, open }: BasicFilterPropsType) => {
  
  const { scope: scopePrime, specificScope: specificScopePrime } = useRouter();
  const specificScope = forceScope || specificScopePrime;
  const scope = forceScope || scopePrime;
  const { [FILTER_KEYS.ZONE_TYPE]: zoneType = TEAM } = useFiltersState(specificScope, FILTER_KEYS.ZONE_TYPE);
  const { changeFilterData } = useFiltersDispatch();
  const [optionSelected, setOptionSelected] = useState<ZoneTypeFilterData>(zoneType);
  const [appliqued, setAppliqued] = useState(false);
  
  const li: JSX.Element[] = [];
  ZONE_TYPE.types.forEach((zoneT: string) => {
    li.push(
      <li key={(scope ? scope + '-' : '') + zoneT}>
        <div className="radio">
          <input
            id={(scope ? scope + '-' : '') + 'radio-' + zoneT}
            name={(scope ? scope + '-' : '') + `radio-${zoneT}`}
            type="radio"
            checked={optionSelected === zoneT}
            onChange={() => {
              setOptionSelected(zoneT);
              setAppliqued(true);
            }}
          />
          <label
            id={(scope ? scope + '-' : '') + 'radio-label-' + zoneT}
            htmlFor={(scope ? scope + '-' : '') + 'radio-' + zoneT}
            style={{ fontWeight: optionSelected === zoneT ? 'bold' : undefined }}
            className="radio-label"
          >
            {zoneT}
          </label>
        </div>
      </li>
    );
  });
  return (
    <Dropdown
      id="zone-type-filter-dropdown"
      className="zone-type"
      show={show}
      onToggle={show ? () => {
        close();
        setOptionSelected(zoneType);
      } : open}
    >
      <Dropdown.Toggle
        id={`${scope}:dropdown-zone-type`} 
        className="btn-border"
        style={scopeIsModalPlayer(scope) ? { width: '99px' } : {}}
        disabled={customView}
      >
        <label className={appliqued ? 'appliqued' : ''}>{ZONE_TYPE.title}</label>
        {optionSelected}
      </Dropdown.Toggle>
      <Dropdown.Menu
      id="zone-type-dropdown-menu"
      >
        <ul>
          {li}
        </ul>
        <div className="footer-s">
          <button className="btn-transparet" onClick={() => {
            setOptionSelected(zoneType);
            close();
          }}>Cancel
          </button>
          <button
            className="btn-blue"
            onClick={() => {
              close();
              changeFilterData(optionSelected, FILTER_KEYS.ZONE_TYPE, specificScope)();
            }}
          >
            Apply
          </button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ZoneTypeFilter;
export * from './types';